import type { BooleanSwitch } from "types";
import { ApiRoutes } from "consts/enpoints/api";
import { SetupIdentifier } from "consts/setups";
import { HttpVerb } from "consts/api";
import { fetchApi, updateOrCreateResource } from "infrastructure/api";
import type { Setup } from "./types";

export const getSetups = (queryParams = '') =>
    fetchApi(`${ApiRoutes.GetSetups()}${queryParams}`);

export const getSetupByIdentifier = (identifier: Setup<string>['identifier']) =>
    fetchApi(ApiRoutes.GetSetups(identifier));

export const getSetupsKYCSwitch = (query: string) =>
    fetchApi(`${ApiRoutes.GetSetups(SetupIdentifier.KycOnOffSwitch)}${query}`, undefined, []);

export const getTicketingSystemSwitch = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetSetups(SetupIdentifier.TicketingOnOffSwitch)}${queryString}`, undefined, []);

export const getTicketingSystemZendeskTicketingSwitch = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetSetups(SetupIdentifier.ZendeskTicketingOnOffSwitch)}${queryString}`, undefined, []);

export const updateOrCreateSetup = (body: Partial<Setup<string>>) =>
    updateOrCreateResource({
        body,
        getRoute: ApiRoutes.PutSetups,
        getId: setup => setup.coreId
    });

    export const updateOrCreateSetupGrupPivot = (body: Partial<Setup<string>>) =>
        
    updateOrCreateResource({
        body,
        getRoute: ApiRoutes.PostSetupGroupPivot
    });

export const deleteSetup = ({ coreId, MOR }: Pick<Setup<string>, 'coreId' | 'MOR'>) =>
    fetchApi(ApiRoutes.DeleteSetup(coreId), {
        method: HttpVerb.Delete,
        headers: {
            MOR
        }
    });

export const updateSetupsKYCSwitch = (body: Pick<
    Setup<SetupIdentifier.KycOnOffSwitch>,
    | 'MOR'
    | 'setupValue'
    | 'userId'
>) =>
    fetchApi(ApiRoutes.GetSetups(SetupIdentifier.KycOnOffSwitch), {
        method: HttpVerb.Put,
        body
    });

export const updateTicketingSystemSwitch = (body: Pick<
    Setup<SetupIdentifier.TicketingOnOffSwitch, BooleanSwitch>,
    | 'MOR'
    | 'setupValue'
    | 'userId'
>) =>
    fetchApi(ApiRoutes.GetSetups(SetupIdentifier.TicketingOnOffSwitch), {
        method: HttpVerb.Put,
        body
    });

export const updateTicketingSystemZendeskTicketingSwitch = (body: Pick<
    Setup<SetupIdentifier.ZendeskTicketingOnOffSwitch, BooleanSwitch>,
    | 'MOR'
    | 'setupValue'
    | 'userId'
>) =>
    fetchApi(ApiRoutes.GetSetups(SetupIdentifier.ZendeskTicketingOnOffSwitch), {
        method: HttpVerb.Put,
        body
    });
